import { render, staticRenderFns } from "./RichText.vue?vue&type=template&id=8fbdb7b4&scoped=true&"
import script from "./RichText.vue?vue&type=script&lang=ts&"
export * from "./RichText.vue?vue&type=script&lang=ts&"
import style0 from "./RichText.vue?vue&type=style&index=0&id=8fbdb7b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbdb7b4",
  null
  
)

export default component.exports